/** @flow */
import { apiBase } from "../config";

export function _fetchMatch(shortId: string): Promise<{}> {
  return _fetchMatches()
    .then(matches => {
      return matches.find(m => m.shortId === shortId);
    });
}

export function _fetchMatches(): Promise<Array<{}>> {
  return fetch(apiBase + '/matches', {
    headers: {
      'accept': 'application/json'
    }
  })
    .then(res => res.json())
}

export default function (state, action) {

}



// WEBPACK FOOTER //
// ./src/modules/matches.js